// Reproductor de repeticiones: cada "salto" a un punto/set pide un clip nuevo a MediaMTX
// (su servidor de playback no admite Range requests), así que en vez de tocar currentTime
// simplemente remontamos el <video> con la nueva URL vía key={src}.
export function MatchVideoPlayer({ src, className = "" }: { src: string; className?: string }) {
  return <video key={src} src={src} controls autoPlay className={`bg-ink-950 ${className}`} />;
}
